function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import React from 'react';
import FontAwesome from 'react-fontawesome';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import UploadButton from "../button/UploadButton";
import InputLabel from "./InputLabel";
import { _CoreInputWrapper, _Icon, _InputWrapperDiv, _TextInput, InputBlockDiv, InputPrefix } from "./inputStyles";
import ToolTip from "../ui/ToolTip/ToolTip";
import TextErrorContainer from "./TextErrorContainer";
import classNames from "../../../util/classNames";
import uuid from 'uuid/v4';
var TextInput = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(TextInput, _React$PureComponent);
  var _super = _createSuper(TextInput);
  function TextInput() {
    var _this;
    _classCallCheck(this, TextInput);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _possibleConstructorReturn(_this, (_this = _super.call.apply(_super, [this].concat(args)), _this.id = uuid(), _assertThisInitialized(_this)));
  }
  _createClass(TextInput, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        className = _this$props.className,
        _this$props$disabled = _this$props.disabled,
        disabled = _this$props$disabled === void 0 ? false : _this$props$disabled,
        displayFlex = _this$props.displayFlex,
        error = _this$props.error,
        handlePrefixIcon = _this$props.handlePrefixIcon,
        handleSuffixIcon = _this$props.handleSuffixIcon,
        highlight = _this$props.highlight,
        input = _this$props.input,
        inputId = _this$props.inputId,
        inputPrefix = _this$props.inputPrefix,
        inputType = _this$props.inputType,
        inputValue = _this$props.inputValue,
        isInviteStudents = _this$props.isInviteStudents,
        labelText = _this$props.labelText,
        meta = _this$props.meta,
        name = _this$props.name,
        noPadding = _this$props.noPadding,
        prefixIcon = _this$props.prefixIcon,
        reference = _this$props.reference,
        _this$props$required = _this$props.required,
        required = _this$props$required === void 0 ? false : _this$props$required,
        subLabel = _this$props.subLabel,
        subTextInput = _this$props.subTextInput,
        suffixIcon = _this$props.suffixIcon,
        tooltip = _this$props.tooltip,
        uploadButton = _this$props.uploadButton,
        validation = _this$props.validation,
        visible = _this$props.visible;
      var wrapperClassName = classNames([className, required ? 'required' : null, error ? 'error' : null, disabled ? 'disabled' : null, visible === false ? 'hidden' : null, 'text-input']);
      var dataInputId = name || inputId || input && input.name;
      var value = inputValue || input && input.value || '';
      var elementClassName = value === '' ? 'empty' : null;
      var textErrorContainer = error || meta && meta.touched && meta.error;
      return /*#__PURE__*/React.createElement(_CoreInputWrapper, {
        className: wrapperClassName,
        displayFlex: displayFlex
      }, /*#__PURE__*/React.createElement(_InputWrapperDiv, {
        className: isInviteStudents ? 'input-label' : '',
        noPadding: noPadding
      }, /*#__PURE__*/React.createElement(InputLabel, {
        labelText: labelText || input && input.labelText,
        required: required,
        validationStatus: validation,
        subLabel: subLabel,
        htmlFor: this.id
      }, tooltip && /*#__PURE__*/React.createElement(ToolTip, {
        text: tooltip,
        name: "info-circle"
      }))), /*#__PURE__*/React.createElement(_InputWrapperDiv, {
        className: isInviteStudents ? 'input-field' : '',
        noPadding: noPadding
      }, /*#__PURE__*/React.createElement(InputBlockDiv, {
        highlight: highlight,
        subTextInput: subTextInput
      }, prefixIcon && /*#__PURE__*/React.createElement(_Icon, {
        onClick: handlePrefixIcon
      }, /*#__PURE__*/React.createElement(FontAwesome, {
        name: prefixIcon
      })), inputPrefix && /*#__PURE__*/React.createElement(InputPrefix, null, inputPrefix), /*#__PURE__*/React.createElement(_TextInput, _extends({
        id: this.id
      }, input, this.props, {
        className: elementClassName,
        "data-inputid": dataInputId,
        innerRef: reference,
        type: inputType,
        value: value
      })), suffixIcon && /*#__PURE__*/React.createElement(_Icon, {
        onClick: handleSuffixIcon
      }, /*#__PURE__*/React.createElement(FontAwesome, {
        name: suffixIcon
      })), uploadButton && /*#__PURE__*/React.createElement(UploadButton, this.props)), /*#__PURE__*/React.createElement(TextErrorContainer, {
        error: textErrorContainer
      })), /*#__PURE__*/React.createElement(ReactTooltip, null));
    }
  }]);
  return TextInput;
}(React.PureComponent); // @ts-expect-error TODO
TextInput.propTypes = {
  disabled: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  inputId: PropTypes.string,
  name: PropTypes.string,
  required: PropTypes.bool
};
export default TextInput;